import React from 'react';

import { AuthenticatorFooter } from '@components';

export const AuthenticatorFooterPlaceholder: React.FC = () => {
	return <AuthenticatorFooter />;
};
